export function SET_LIST(state, {
    type,
    items
}) {
    state.goods = items;
}
export function SET_PRODUCT_INFO(state, {
    type,
    items
}) {
    state.product = items
}
export function SET_ASSESS(state, {
    type,
    items
}) {
    state.assess = items.data
}
export function SET_BRANDS(state, {
    type,
    items
}) {
    state.brands = items
}
export function SET_ZHIMA(state, {
    type,
    items
}) {
    state.zhima = items
}
export function SET_STATS(state, {
    type,
    items
}) {
    state.stats = items
}
export function SET_ISCITY(state, {
    type,
    items
}) {
    state.iscity = items
}
export function SET_REGION(state, {
    type,
    items
}) {
    state.region = items
}
export function SET_SOURCE(state, {
    type,
    items
}) {
    state.source = items
}
export function SET_USER(state, {
    type,
    items
}) {
    state.user = items
}
export function SET_CREATE(state, {
    type,
    items
}) {
    state.ordersn = items
}
export function SET_ARTICLE_LIST(state, {
    type,
    items
}) {
    state.articles = items
}
export function SET_ORDER_LIST(state, {
    type,
    items
}) {
    state.orders = items
}
export function SET_ORDER_DATA(state, {
    type,
    items
}) {
    state.order = items
}
export function SET_CANCEL_DATA(state, {
    type,
    items
}) {
    state.cancel = items
}
export function SET_EXPRESS_DATA(state, {
    type,
    items
}) {
    state.express = items
}
export function SET_TEST_DATA(state, {
    type,
    items
}) {
    state.test = items
}
export function SET_COMMENT_DATA(state, {
    type,
    items
}) {
    state.comment = items
}
export function SET_STATUS_DATA(state, {
    type,
    items
}) {
    state.status = items
}
export function SET_ARTICLE_DATA(state, {
    type,
    items
}) {
    state.article = items
}
export function SET_HOTWORD_DATA(state, {
    type,
    items
}) {
    state.hotword = items
}
export function SET_RECENT_DATA(state, {
    type,
    items
}) {
    state.recent = items
}
export function SET_CART_DATA(state, {
    type,
    items
}) {
    state.cart = items
}
export function SET_MAP_DATA(state, {
    type,
    items
}) {
    state.map = items
}
export function SET_USER_DATA(state, {
    type,
    items
}) {
    state.user = items.data
}
export function SET_BONUS_DATA(state, {
    type,
    items
}) {
    state.bonus = items
}
export function SET_BONUS_LIST(state, {
    type,
    items
}) {
    state.bonuslist = items
}
export function SET_ATBONUS_DATA(state, items) {
    state.atbonus = items.item
}
export function SET_TOKEN_DATA(state, {
    type,
    items
}) {
    state.token = items
}
export function SET_WALLET_DATA(state, {
    type,
    items
}) {
    state.wallet = items
}
export function SET_WALLETS_DATA(state, {
    type,
    items
}) {
    state.wallets = items
}
export function SET_WALLET_RELEASE(state, {
    type,
    items
}) {
    state.rewallet = items
}
export function SET_ACCOUNT_DATA(state, {
    type,
    items
}) {
    state.account = items
}
export function SET_SMS_DATA(state, {
    type,
    items
}) {
    state.sms = items
}
export function SET_INVITE_DATA(state, {
    type,
    items
}) {
    state.invite = items
}
export function SET_OLDNEW_DATA(state, {
    type,
    items
}) {
    state.oldnew = items
}
export function SET_OLDNEW_LIST(state, {
    type,
    items
}) {
    state.oldnews = items
}


// WEBPACK FOOTER //
// ./src/store/mutations.js